// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import BillingService from '@/services/billing-service';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import SubscriptionContext from '@/utils/subscription-context';
import { useQuery } from '@tanstack/react-query';
import ManageInvoiceForm from "@/PageComponents/Invoice/ManageInvoiceForm";
import { createFileRoute } from '@tanstack/react-router'

function CreateInvoice() {
  const router = useRouter();
  const { id, module, moduleID, rootModule, customerID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const subscriptionContext = useContext(SubscriptionContext);
  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const { data: copyFromInvoice } = useQuery(
    ['invoice', id],
    () => Fetch.get({ url: `/Invoice/${id}` }),
    { enabled: !!id }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  const getAccessStatus = async () => {
    const [subscriptionInfo] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  if (!company) return null;
  if (id && !copyFromInvoice) return null;

  return (
    <div className="manage-container">
      <ManageInvoiceForm
        mode={'page'}
        isNew={true}
        copyFromInvoice={copyFromInvoice}
        module={module ? +module : undefined}
        moduleID={moduleID}
        rootModule={rootModule ? +rootModule : undefined}
        customerID={customerID}
        accessStatus={accessStatus}
        company={company}
      />
    </div>
  );
}

export default CreateInvoice;

export const Route = createFileRoute('/_authenticated/invoice/create')({ component: CreateInvoice })
